'use client';

import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
// https://locize.com/blog/next-13-app-dir-i18n/
import { useEffect } from 'react';
import { initReactI18next, useTranslation as useTranslationOrg } from 'react-i18next';
import { getOptions, languages } from './settings';
const runsOnServerSide = typeof window === 'undefined';

//
i18next.use(initReactI18next).use(LanguageDetector).use(resourcesToBackend((language, namespace) => import(`./locales/${language}/${namespace}.json`))).init({
  ...getOptions(),
  lng: undefined,
  // let detect the language on client side
  detection: {
    order: ['path', 'htmlTag', 'cookie', 'navigator']
  },
  preload: runsOnServerSide ? languages : []
});
export function useTranslation(lng, ns, options) {
  const ret = useTranslationOrg(ns, options);
  const {
    i18n
  } = ret;
  if (runsOnServerSide && i18n.resolvedLanguage !== lng) {
    i18n.changeLanguage(lng);
  } else {
    useEffect(() => {
      if (i18n.resolvedLanguage === lng) return;
      i18n.changeLanguage(lng);
    }, [lng, i18n]);
  }
  return ret;
}